import * as React from 'react'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core';


interface IProps {
    classes: any,
    children: any
    onClick?: () => void
    disabled?: boolean
}

const styles = (theme:any) => ({
    close: {
        padding: theme.spacing.unit / 2,
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    }
});

class FixedFabButton extends React.Component<IProps> {

    public state: any = {
        snackbarOpen: false
    }

    public render() {
        const {onClick, classes, disabled, children} = this.props
        const handleClick = () => {
            if (onClick) {
                onClick()
            }
        }

        return (
            <>
                <div
                    style={{
                        position: 'fixed',
                        right: '20px',
                        bottom: '20px',
                        color: '#fff',
                        fontWeight: 500,
                        zIndex: 99
                    }}
                    onClick={
                        disabled ? () => this.setState({snackbarOpen: true}) : undefined
                    }
                >
                    <Button
                        variant="fab"
                        aria-label="next"
                        color="primary"
                        onClick={handleClick}
                        disabled={disabled}
                    >
                        {children}
                    </Button>

                </div>
                <Snackbar
                    open={this.state.snackbarOpen}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left'
                    }}

                    autoHideDuration={3000}
                    onClose={() => this.setState({ snackbarOpen: false })}
                    message={"Please select some content to proceed."}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            className={classes.close}
                            onClick={() => this.setState({ snackbarOpen: false })}
                        >
                            <CloseIcon />
                        </IconButton>
                    ]}
                />
            </>
        )
    }
}

export default withStyles(styles)(FixedFabButton);


// WEBPACK FOOTER //
// ./src/shared/FixedFabButton.tsx